import { render, staticRenderFns } from "./CompanyInformationAddressList.vue?vue&type=template&id=f39cad88&scoped=true&"
import script from "./CompanyInformationAddressList.vue?vue&type=script&lang=js&"
export * from "./CompanyInformationAddressList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInformationAddressList.vue?vue&type=style&index=0&id=f39cad88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39cad88",
  null
  
)

export default component.exports